import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Philosophy from "./components/Philosophy";
import About from "./components/About";
import Services from "./components/Services";
import Shop from "./components/Shop";
import Testimonials from "./components/Testimonials";
import Journal from "./components/Journal";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import AdminIntakes from "./components/AdminIntakes";
import { PaymentSuccess, PaymentCancel } from "./components/Payment";

const Home = () => {
  return (
    <div className="App bg-[#0A0714] text-[#EDE3D0]">
      <Navbar />
      <main>
        <Hero />
        <Philosophy />
        <About />
        <Services />
        <Shop />
        <Testimonials />
        <Journal />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin" element={<AdminIntakes />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
      </Routes>
      <Toaster />
    </BrowserRouter>
  );
}

export default App;
